/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionFetchedData
 */
export interface SectionFetchedData {
    /**
     * 
     * @type {string}
     * @memberof SectionFetchedData
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof SectionFetchedData
     */
    data: object;
}

/**
 * Check if a given object implements the SectionFetchedData interface.
 */
export function instanceOfSectionFetchedData(value: object): value is SectionFetchedData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SectionFetchedDataFromJSON(json: any): SectionFetchedData {
    return SectionFetchedDataFromJSONTyped(json, false);
}

export function SectionFetchedDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionFetchedData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'data': json['data'],
    };
}

export function SectionFetchedDataToJSON(json: any): SectionFetchedData {
    return SectionFetchedDataToJSONTyped(json, false);
}

export function SectionFetchedDataToJSONTyped(value?: SectionFetchedData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'data': value['data'],
    };
}

